import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'core/common/hooks';
import { europeanCountries, UserLocation } from '../entities';
import { fetchUserLocationRequest, updateUserLocation } from '../store/actions';
import { getUserLocation, getUserLocationLoadingStatus } from '../store/selectors';

export const useUserLocation = () => {
  const dispatch = useDispatch();

  const location = useSelector(getUserLocation);
  const loadingStatus = useSelector(getUserLocationLoadingStatus);

  const isEuropean = europeanCountries.includes(location.locale);

  const fetchUserLocation = useCallback(() => {
    dispatch(fetchUserLocationRequest());
  }, [dispatch]);

  const doUpdateUserLocation = useCallback(
    (userLocation: UserLocation) => {
      dispatch(updateUserLocation(userLocation));
    },
    [dispatch],
  );

  return {
    country: location.country,
    locale: location.locale,
    region: location.region,
    isEuropean,
    loadingStatus,
    fetchUserLocation,
    updateUserLocation: doUpdateUserLocation,
  };
};
